export default {
  brand: 'USFansLink',
  nav: {
    home: 'Accueil',
    spreadsheet: 'Spreadsheet',
    categories: 'Catégories',
    guide: 'Guide',
    safety: 'Sécurité',
    shopGuide: "Guide d'achat",
  },
  hero: {
    eyebrow: 'Le centre de ressources USFans',
    title: 'USFans Spreadsheet — trouvez créateurs, liens et ressources plus vite',
    subtitle:
      'Découvrez une ressource USFans spreadsheet structurée avec des liens de créateurs, des guides de recherche, des comparaisons, des mises à jour et des informations de sécurité — le tout au même endroit.',
    ctaPrimary: 'USFans Spreadsheet',
    ctaSecondary: 'Acheter maintenant',
    searchPlaceholder: 'Recherchez des créateurs, liens, avis ou ressources USFans...',
    trust: 'Ressources organisées • Guides actualisés • Informations axées sur la sécurité',
  },
  category: {
    title: 'Parcourir par catégorie',
    subtitle:
      'Découvrez les dernières collections USFans — chaussures, vêtements, accessoires et plus depuis notre boutique principale.',
    dropdownLabel: 'Choisissez une catégorie',
    dropdownPlaceholder: 'Sélectionnez une catégorie à visiter...',
    viewCategory: 'Voir la catégorie',
  },
  categories: {
    shoes: 'Chaussures',
    hoodies: 'Sweats / Pulls',
    tshirts: 'T-shirts',
    jackets: 'Vestes',
    pants: 'Pantalons / Shorts',
    headwear: 'Couvre-chefs',
    sets: 'Ensembles',
    underwear: 'Sous-vêtements / Caleçons',
    jersey: 'Maillots',
    accessories: 'Accessoires',
    bags: 'Sacs',
    belts: 'Ceintures',
    perfumes: 'Parfums',
    other: 'Autres articles',
  },
  valueProp: {
    title: 'Tout ce qu\'il faut pour naviguer dans les ressources USFans',
    cards: [
      { title: 'USFans Spreadsheet', text: 'Trouvez des ressources et des liens de créateurs organisés.' },
      { title: 'Recherche de créateurs', text: 'Découvrez des méthodes pratiques de recherche et d\'investigation.' },
      { title: 'Avis et guides', text: 'Explorez avis, coûts, coupons, légitimité et tutoriels.' },
      { title: 'Centre de sécurité', text: 'Apprenez à repérer les liens suspects et à protéger vos informations.' },
    ],
  },
  core: {
    title: 'Qu\'est-ce que le USFans Spreadsheet ?',
    copy: 'Le USFans Spreadsheet est une ressource structurée conçue pour faciliter la découverte de créateurs et la recherche de liens USFans. Explorez des informations organisées, des guides et des ressources utiles depuis un hub central.',
    tableHeaders: ['Créateur', 'Catégorie', 'Lien', 'Statut', 'Mis à jour'],
    tableRows: [
      ['Créateur Un', 'Chaussures', 'Voir', 'Actif', 'Cette semaine'],
      ['Créateur Deux', 'Sweats', 'Voir', 'Actif', 'Cette semaine'],
      ['Créateur Trois', 'T-shirts', 'Voir', 'Actif', 'Le mois dernier'],
      ['Créateur Quatre', 'Maillots', 'Voir', 'Actif', 'Le mois dernier'],
      ['Créateur Cinq', 'Accessoires', 'Voir', 'Actif', 'Ce mois-ci'],
    ],
    cta: 'Ouvrir le USFans Spreadsheet',
  },
  intent: {
    title: 'Sujets de recherche populaires',
    subtitle: 'Des réponses rapides aux questions que les gens posent le plus sur USFans.',
    cards: [
      'Avis USFans',
      'Frais de livraison USFans',
      'Coupon USFans',
      'Code promo USFans',
      'Entrepôt USFans',
      'USFans est-il légitime ?',
    ],
  },
  comparison: {
    title: 'Comparez vos options',
    subtitle: 'Choisissez l\'approche qui correspond à votre façon de naviguer et de rechercher.',
    headers: ['Ressource', 'Idéal pour', 'Organisation', 'Facilité de recherche'],
    rows: [
      ['USFans Spreadsheet', 'Recherche structurée', 'Élevée', 'Élevée'],
      ['Annuaire', 'Navigation', 'Moyenne', 'Élevée'],
      ['Recherche manuelle', 'Consultations rapides', 'Faible', 'Moyenne'],
    ],
  },
  safety: {
    title: 'Naviguez plus sereinement dans les ressources USFans',
    copy: 'Vérifiez les domaines, évitez les redirections suspectes, ne partagez jamais vos mots de passe ni vos données de paiement, évitez les téléchargements inconnus, méfiez-vous du hameçonnage et respectez la vie privée des créateurs.',
    cta: 'Visiter le Centre de sécurité',
  },
  featuredGuide: {
    eyebrow: 'Guide à la une',
    title: 'USFans Spreadsheet : le guide complet',
    excerpt:
      'Découvrez ce qu\'est le USFans Spreadsheet, comment l\'utiliser pour trouver des créateurs et des liens, et comment naviguer en toute sécurité.',
    readMore: 'Lire le guide',
  },
  pillar: {
    eyebrow: 'Bibliothèque de ressources USFans',
    title: 'Guides USFans',
    subtitle: "Des ressources détaillées sur la recherche de créateurs, les liens, la sécurité, les avis et plus.",
    readMore: 'Lire le guide',
    backHome: "Retour à l'accueil",
  },
  finalCta: {
    title: 'Prêt à explorer les ressources du USFans Spreadsheet ?',
    copy: 'Commencez par le USFans Spreadsheet et découvrez des guides utiles, des comparaisons et des ressources depuis un hub organisé.',
    ctaPrimary: 'Explorer le USFans Spreadsheet',
    ctaSecondary: 'Visiter le site principal',
  },
  footer: {
    tagline: 'USFansLink est une ressource d\'information indépendante. Les liens, les informations et les services tiers peuvent évoluer au fil du temps.',
    disclaimer: 'Les utilisateurs doivent vérifier de façon indépendante les informations importantes et suivre des pratiques de sécurité en ligne adaptées.',
    navTitle: 'Explorer',
    navLinks: ['Accueil', 'Spreadsheet', 'Créateurs', 'Guides', 'Sécurité'],
    legalTitle: 'Légal',
    legalLinks: ['À propos', 'Confidentialité', 'Conditions', 'Avertissement', 'Contact'],
    categoriesTitle: 'Catégories',
    copyright: 'Tous droits réservés.',
  },
};